import { useCallback } from 'react';

import { formatSocialCurrency, toLocaleCurrency } from '@/utils/numeric/currency';

import { useHasSocialWallet } from './use-has-social-wallet';
import { useSocialCurrencyStore } from './use-social-currency';

export const useFormatCurrency = () => {
    const hasSocialWallet = useHasSocialWallet();
    const activeCurrency = useSocialCurrencyStore(state => state.activeCurrency);

    const formatCurrency = useCallback(
        (value: number | string) =>
            hasSocialWallet ? formatSocialCurrency(value, activeCurrency) : toLocaleCurrency(value),
        [hasSocialWallet, activeCurrency]
    );

    return { formatCurrency };
};
